import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { useTranslation } from 'react-i18next';

// Coordinates
// Hoàng Sa (Paracel Islands) - approximate center of the archipelago
const HOANG_SA_COORDS = [16.5, 112.0];
// Trường Sa (Spratly Islands) - approximate center of the archipelago
const TRUONG_SA_COORDS = [8.6, 111.9];

// Custom marker icon for sovereignty markers (red flag/teardrop)
const createSovereigntyIcon = () => {
  return L.divIcon({
    className: 'sovereignty-marker',
    html: `<div style="position: relative; width: 32px; height: 32px;">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 2C8.72 2 3 8.72 3 17C3 27.75 16 34 16 34C16 34 29 27.75 29 17C29 8.72 23.28 2 16 2Z"
          fill="#DC2626" stroke="white" stroke-width="1.5"/>
        <circle cx="16" cy="16" r="5" fill="#FEE2E2"/>
        <path d="M13.5 14.5H18.5L19 16L16 19L13 16L13.5 14.5Z" fill="#DC2626"/>
      </svg>
    </div>`,
    iconSize: [32, 32],
    iconAnchor: [16, 30],
    popupAnchor: [0, -30],
  });
};

const SovereigntyMarkers = () => {
  const { t } = useTranslation();
  const icon = createSovereigntyIcon();

  return (
    <>
      {/* Hoàng Sa (Paracel Islands) */}
      <Marker position={HOANG_SA_COORDS} icon={icon}>
        <Popup>
          <div className="text-sm min-w-[160px]">
            <p className="font-bold text-gray-900">{t('sovereignty.hoangSa')}</p>
            <p className="text-gray-500 text-xs mt-1">{t('sovereignty.paracelIslands')}</p>
            <p className="text-gray-400 text-xs mt-1">16.5°N, 112.0°E</p>
          </div>
        </Popup>
      </Marker>

      {/* Trường Sa (Spratly Islands) */}
      <Marker position={TRUONG_SA_COORDS} icon={icon}>
        <Popup>
          <div className="text-sm min-w-[160px]">
            <p className="font-bold text-gray-900">{t('sovereignty.truongSa')}</p>
            <p className="text-gray-500 text-xs mt-1">{t('sovereignty.spratlyIslands')}</p>
            <p className="text-gray-400 text-xs mt-1">8.6°N, 111.9°E</p>
          </div>
        </Popup>
      </Marker>
    </>
  );
};

export default SovereigntyMarkers;